// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/trading_execution_route.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/trading_execution_route.proto.
 */
export const file_bfftypes_v1_trading_execution_route: GenFile = /*@__PURE__*/
  fileDesc("CiliZmZ0eXBlcy92MS90cmFkaW5nX2V4ZWN1dGlvbl9yb3V0ZS5wcm90bxILYmZmdHlwZXMudjEqhAMKFVRyYWRpbmdFeGVjdXRpb25Sb3V0ZRInCiNUUkFESU5HX0VYRUNVVElPTl9ST1VURV9VTlNQRUNJRklFRBAAEiQKIFRSQURJTkdfRVhFQ1VUSU9OX1JPVVRFX0VORUNIQUlOEAESKAokVFJBRElOR19FWEVDVVRJT05fUk9VVEVfRVNRVUFSRV9MSVZFEAISIgoeVFJBRElOR19FWEVDVVRJT05fUk9VVEVfTUFOVUFMEAMSKgomVFJBRElOR19FWEVDVVRJT05fUk9VVEVfQkFDS1VQX1JFR1VMQVIQBBIrCidUUkFESU5HX0VYRUNVVElPTl9ST1VURV9CQVNFTE9BRF9NQVJLRVQQBRIqCiZUUkFESU5HX0VYRUNVVElPTl9ST1VURV9GT1JXQVJEX01BUktFVBAGEiEKHVRSQURJTkdfRVhFQ1VUSU9OX1JPVVRFX09USEVSEAciBAgIEAgqIFRSQURJTkdfRVhFQ1VUSU9OX1JPVVRFX0lOVEVSTkFMQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw");

/**
 * TradingExecutionRoute identifies how a bilateral electricity trade was
 * executed and sourced into ebalance. Mirrors backend
 * types.v1.TradingExecutionRoute 1:1. Hosted under bfftypes/v1 for
 * BFF-local reuse across service packages.
 *
 * @generated from enum bfftypes.v1.TradingExecutionRoute
 */
export enum TradingExecutionRoute {
  /**
   * @generated from enum value: TRADING_EXECUTION_ROUTE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * enechain プラットフォーム経由で約定した取引。
   *
   * @generated from enum value: TRADING_EXECUTION_ROUTE_ENECHAIN = 1;
   */
  ENECHAIN = 1,

  /**
   * eSquare Live (eSL) API 経由で同期した取引。
   *
   * @generated from enum value: TRADING_EXECUTION_ROUTE_ESQUARE_LIVE = 2;
   */
  ESQUARE_LIVE = 2,

  /**
   * ユーザーが手入力で登録した取引 (旧値)。新規登録の select には出さない。
   *
   * @generated from enum value: TRADING_EXECUTION_ROUTE_MANUAL = 3;
   */
  MANUAL = 3,

  /**
   * 常時BU — みなし小売電気事業者 (旧一電小売) からの常時バックアップの制度的調達。
   * 受渡区分上は BG 渡しだが、約定経路として独立カテゴリに分類する
   * (supply-48-data.md / supply-demand-gap.md)。
   *
   * @generated from enum value: TRADING_EXECUTION_ROUTE_BACKUP_REGULAR = 4;
   */
  BACKUP_REGULAR = 4,

  /**
   * ベースロード市場経由で約定した取引。
   *
   * @generated from enum value: TRADING_EXECUTION_ROUTE_BASELOAD_MARKET = 5;
   */
  BASELOAD_MARKET = 5,

  /**
   * 先渡し市場経由で約定した取引。
   *
   * @generated from enum value: TRADING_EXECUTION_ROUTE_FORWARD_MARKET = 6;
   */
  FORWARD_MARKET = 6,

  /**
   * その他 (上記いずれにも当てはまらない相対約定)。
   *
   * @generated from enum value: TRADING_EXECUTION_ROUTE_OTHER = 7;
   */
  OTHER = 7,
}

/**
 * Describes the enum bfftypes.v1.TradingExecutionRoute.
 */
export const TradingExecutionRouteSchema: GenEnum<TradingExecutionRoute> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_trading_execution_route, 0);

